import { FC } from 'react';

import styles from './styles.module.scss';

export const Subtitle: FC<{
    text: string;
}> = ({ text }) => {
    return <h4 className={styles.subtitle}>{text}</h4>;
};
